import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadSimpleUserPrivilegeListActions } from 'saga/acl/ducks';
import { selectExistsSimpleUserPrivileges, selectHasSimpleUserPrivilege } from 'saga/acl/simpleUserPrivileges/ducks';

/**
 * EntityRefNo can be undefined, if entityRefNo is undefined, then partyRefNo is taken from context
 * Use entityRefNo if filled
 */
export const useHasSimpleUserPrivileges = (
  privilegeTypes: string[],
  entityRefNo: string | undefined = undefined
): Record<string, boolean> => {
  const existsSimpleUserPrivileges = useSelector(selectExistsSimpleUserPrivileges);
  const hasSimpleUserPrivilege = useSelector(selectHasSimpleUserPrivilege);
  const dispatch = useDispatch();

  const privilegesExists = existsSimpleUserPrivileges(entityRefNo);

  useEffect(() => {
    if (!privilegesExists) {
      dispatch(
        loadSimpleUserPrivilegeListActions.request({
          entityRefNo: entityRefNo,
          forceFreshData: true,
        })
      );
    }
  }, [entityRefNo, privilegesExists]);

  return privilegeTypes.reduce(
    (acc, privilegeType) => ({
      ...acc,
      [privilegeType]: hasSimpleUserPrivilege(privilegeType, entityRefNo),
    }),
    {}
  );
};
